import React from 'react';

import I18n from '@wetransfer/transfer/modules/i18n';

import { MobileWebDescriptionProps } from './types';

export const MobileWebDescription = React.memo(function MobileWebDescription({
  totalItemsCount,
  currentSize,
  expiration,
}: MobileWebDescriptionProps) {
  return (
    <>
      {I18n.t('transfer.download.files_nosize', {
        count: totalItemsCount,
      })}
      <span className="downloader__option-separator">
        {I18n.size(currentSize, { precision: 0 })}
      </span>
      {expiration}
    </>
  );
});
